<template>
    <codemirror v-model="localCode" :options="cmOptions" @ready="onReady" />
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/addon/edit/closetag.js';

export default {
    name: 'HtmlCodeEditor',
    components: { codemirror },
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            required: false,
            default: () => {
                return {
                    mode: 'htmlmixed',
                    theme: 'default',
                    lineNumbers: true,
                    autoCloseTags: true,
                    readOnly: false
                };
            }
        }
    },
    computed: {
        localCode: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    data() {
        return {
            cmOptions: {
                mode: 'htmlmixed',
                theme: 'default',
                lineNumbers: true,
                autoCloseTags: true,
                readOnly: false
            }
        };
    },
    methods: {
        onReady(cm) {
            this.cmInstance = cm;
            // Gọi refresh sau khi gắn tab (nếu cần)
            this.$nextTick(() => cm.refresh());
        },
        refreshEditor() {
            if (this.cmInstance) {
                this.cmInstance.refresh();
            }
        },
        setReadOnly(readOnly = true) {
            if (this.cmInstance) {
                this.cmInstance.setOption('readOnly', readOnly);
            }
        }
    },
    watch: {
        config: {
            handler: function (newConfig) {
                this.cmOptions = {
                    ...this.cmOptions,
                    ...newConfig
                };
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style scoped>
.vue-codemirror {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}
</style>
